export default {
  mounted() {
    // attach once component is mounted
    this.$nextTick(() => this.attachInvalidClearHandlers());
  },
  updated() {
    // ensure any newly rendered required fields get listeners
    this.$nextTick(() => this.attachInvalidClearHandlers());
  },
  methods: {


    onCreate(){
      this.show = true;
    },
    onClose(value){
      this.objs = {}
      this.show = false
    },


    preventCode(e){
      const allowedKeys = [
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'Tab',
        'Home',
        'End'
      ];

      // อนุญาตปุ่มควบคุม
      if (allowedKeys.includes(e.key)) return;

      // อนุญาตเฉพาะตัวเลข 0–9
      if (!/^[A-Za-z0-9_-]$/.test(e.key)) {
        e.preventDefault();
      }
    },
    preventNumber(e) {
      const allowedKeys = [
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'Tab',
        'Home',
        'End'
      ];

      // อนุญาตปุ่มควบคุม
      if (allowedKeys.includes(e.key)) return;

      // อนุญาตตัวเลข 0-9
      if (/^[0-9]$/.test(e.key)) return;

      // อนุญาตจุดทศนิยมได้แค่ 1 จุด
      if (e.key === '.') {
        if (e.target.value.includes('.')) {
          e.preventDefault(); // มีจุดแล้ว ห้ามพิมพ์ซ้ำ
        }
        return;
      }

      // นอกเหนือจากนี้ไม่อนุญาต
      e.preventDefault();
    },
    // Validate required labels and mark invalid elements
    validateRequired() {
      const container = this.$el;
      const labels = container.querySelectorAll('label.required');
      let valid = true;
      let firstInvalid = null;

      labels.forEach(label => {
        const wrap = label.parentElement;
        if (!wrap) return;

        // ข้าม label ที่อยู่ในคอลัมน์ที่ซ่อนอยู่ (v-show="false")
        const col = wrap.closest('[style*="display: none"], [style*="display:none"]');
        if (col) return;

        // หา CCol ถัดไป (sibling ของ CCol ที่มี label)
        let nextCol = wrap.nextElementSibling;

        // รองรับ vue-multiselect ก่อน
        // ลองหาใน CCol ถัดไปก่อน (กรณี label กับ input อยู่คนละ CCol)
        let ms = nextCol ? nextCol.querySelector('.multiselect') : null;
        // ถ้าไม่เจอ ลองหาใน CCol เดียวกัน
        if (!ms) ms = wrap.querySelector('.multiselect');

        if (ms) {
          ms.classList.remove('is-invalid');
          const hasValue = !!ms.querySelector('.multiselect__single, .multiselect__tag');
          if (!hasValue) {
            ms.classList.add('is-invalid');
            valid = false;
            if (!firstInvalid) firstInvalid = ms;
          }
          return; // ข้ามไม่ต้องตรวจ input ภายใน multiselect
        }

        // ตรวจสอบ QEditor (ql-editor)
        let qEditor = nextCol ? nextCol.querySelector('.ql-editor') : null;
        if (!qEditor) qEditor = wrap.querySelector('.ql-editor');

        if (qEditor) {
          const quillEditor = qEditor.closest('.quill-editor');
          // const qContainer = qEditor.closest('.ql-container');
          // const qToolbar = quillEditor?.querySelector('.ql-toolbar');

          // ลบ class is-invalid ออกจากทุก element
          if (quillEditor) quillEditor.classList.remove('is-invalid');
          // if (qContainer) qContainer.classList.remove('is-invalid');
          // if (qToolbar) qToolbar.classList.remove('is-invalid');
          // qEditor.classList.remove('is-invalid');

          const content = qEditor.innerHTML.replace(/<[^>]*>/g, '').trim();
          if (!content || content === '<br>') {
            // เพิ่ม class is-invalid ให้ทุก element
            if (quillEditor) quillEditor.classList.add('is-invalid');
            // if (qContainer) qContainer.classList.add('is-invalid');
            // if (qToolbar) qToolbar.classList.add('is-invalid');
            // qEditor.classList.add('is-invalid');
            valid = false;
            if (!firstInvalid) firstInvalid = qEditor;
          }
          return;
        }

        // ตรวจสอบ paragraph <p> สำหรับ style 0 (person selector)
        let pTag = nextCol ? nextCol.querySelector('p.mt-2') : null;
        if (!pTag) pTag = wrap.querySelector('p.mt-2');

        if (pTag) {
          pTag.classList.remove('is-invalid');
          const content = pTag.textContent.trim();
          // ถ้าข้อความว่าง หรือเป็นค่า default ไม่ได้เลือก
          if (!content || content === '' || content.includes('null')) {
            pTag.classList.add('is-invalid');
            pTag.style.border = '1px solid #e55353';
            pTag.style.borderRadius = '4px';
            pTag.style.padding = '8px';
            valid = false;
            if (!firstInvalid) firstInvalid = pTag;
          } else {
            pTag.style.border = '';
            pTag.style.padding = '';
          }
          return;
        }

        // พยายามหา input/select/textarea (กรณีทั่วไป)
        // ลองหาใน CCol ถัดไปก่อน - รองรับ nested CRow
        let input = nextCol ? nextCol.querySelector('input:not([type="hidden"]), textarea, select') : null;
        // ถ้าไม่เจอ ลองหาใน CCol เดียวกัน
        if (!input) input = wrap.querySelector('input:not([type="hidden"]), textarea, select');

        if (input) {
          input.classList.remove('is-invalid');
          const val = (input.value || '').toString().trim();
          if (!val) {
            input.classList.add('is-invalid');
            valid = false;
            if (!firstInvalid) firstInvalid = input;
          }
          return;
        }
      });

      if (!valid && firstInvalid && typeof firstInvalid.scrollIntoView === 'function') {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      // Attach listeners to clear invalid as user fixes inputs
      this.$nextTick(() => this.attachInvalidClearHandlers());

      return valid;
    },

    // Attach listeners that clear is-invalid when values are entered/selected
    attachInvalidClearHandlers() {
      const container = this.$el;
      if (!container) return;

      const labels = container.querySelectorAll('label.required');
      labels.forEach(label => {
        const wrap = label.parentElement;
        if (!wrap) return;

        // หา CCol ถัดไป
        const nextCol = wrap.nextElementSibling;

        // Standard inputs/selects/textareas
        // ลองหาใน CCol ถัดไปก่อน
        let input = nextCol ? nextCol.querySelector('input:not([type="hidden"]), textarea, select') : null;
        // ถ้าไม่เจอ ลองหาใน CCol เดียวกัน
        if (!input) input = wrap.querySelector('input:not([type="hidden"]), textarea, select');

        if (input && !input.dataset.invalidListener) {
          const handler = () => {
            const val = (input.value || '').toString().trim();
            if (val) input.classList.remove('is-invalid');
          };
          input.addEventListener('input', handler);
          input.addEventListener('change', handler);
          input.dataset.invalidListener = 'true';
        }

        // vue-multiselect: clear invalid when a selection exists
        // ลองหาใน CCol ถัดไปก่อน
        let ms = nextCol ? nextCol.querySelector('.multiselect') : null;
        // ถ้าไม่เจอ ลองหาใน CCol เดียวกัน
        if (!ms) ms = wrap.querySelector('.multiselect');

        if (ms && !ms.dataset.invalidListener) {
          const check = () => {
            const hasValue = !!ms.querySelector('.multiselect__single, .multiselect__tag');
            if (hasValue) ms.classList.remove('is-invalid');
          };
          ms.addEventListener('click', check);
          ms.addEventListener('keyup', check);
          const msInput = ms.querySelector('input.multiselect__input');
          if (msInput) {
            msInput.addEventListener('input', check);
            msInput.addEventListener('change', check);
          }
          ms.dataset.invalidListener = 'true';
        }

        // QEditor: clear invalid when content is entered
        let qEditor = nextCol ? nextCol.querySelector('.ql-editor') : null;
        if (!qEditor) qEditor = wrap.querySelector('.ql-editor');

        if (qEditor && !qEditor.dataset.invalidListener) {
          const checkQEditor = () => {
            const content = qEditor.innerHTML.replace(/<[^>]*>/g, '').trim();
            if (content && content !== '<br>') {
              const quillEditor = qEditor.closest('.quill-editor');
              const qContainer = qEditor.closest('.ql-container');
              const qToolbar = quillEditor?.querySelector('.ql-toolbar');

              if (quillEditor) quillEditor.classList.remove('is-invalid');
              if (qContainer) qContainer.classList.remove('is-invalid');
              if (qToolbar) qToolbar.classList.remove('is-invalid');
              qEditor.classList.remove('is-invalid');
            }
          };
          qEditor.addEventListener('input', checkQEditor);
          qEditor.addEventListener('blur', checkQEditor);
          qEditor.dataset.invalidListener = 'true';
        }

        // Paragraph (person selector style 0): clear invalid when changed
        let pTag = nextCol ? nextCol.querySelector('p.mt-2') : null;
        if (!pTag) pTag = wrap.querySelector('p.mt-2');

        if (pTag && !pTag.dataset.invalidListener) {
          // ใช้ MutationObserver เพื่อตรวจจับการเปลี่ยนแปลง
          const observer = new MutationObserver(() => {
            const content = pTag.textContent.trim();
            if (content && content !== '' && !content.includes('null')) {
              pTag.classList.remove('is-invalid');
              pTag.style.border = '';
              pTag.style.padding = '';
            }
          });
          observer.observe(pTag, { childList: true, characterData: true, subtree: true });
          pTag.dataset.invalidListener = 'true';
        }
      });
    }
  }
}
